import { axiosFactory } from './axiosFactory'

export const axiosRefresh = axiosFactory.getAxios('refresh')
